import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Input from "../input/Input";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import { Calendar as CalendarAD } from "primereact/calendar";
// import Calendar from "@sbmdkl/nepali-datepicker-reactjs";
import FileUploadComponent from "../other/fileUploadComponent";
import { NepaliDatePicker } from "nepali-datepicker-reactjs";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import NepaliDatePicker2 from "../other/nepaliDatePicker";

const EditDocDetails = ({ rowData, editDocumentDetail, documentTypeList }) => {
  const [displayEditModal, setDisplayEditModal] = useState(true);
  const { t } = useTranslation();
  const [editDocumentTypeId, setEditDocumentTypeId] = useState(
    rowData.documentTypeId
  );
  const [editDocId, setEditDocId] = useState(rowData.docId);
  const [editIssuedFrom, setEditIssuedFrom] = useState(rowData.issuedFrom);
  const [editIssuedDate, setEditIssuedDate] = useState(
    new Date(rowData.issuedDate)
  );
  const [editFileName, setEditFileName] = useState(rowData.fileName);
  const [editFileId, setEditFileId] = useState(rowData.fileId);
  const [editIssuedDateBs, setEditIssuedDateBs] = useState(
    rowData.issuedDateBs
  );

  const hideModal = () => {
    setDisplayEditModal(false);
  };
  function isValidDate(date) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!date.match(regEx)) return false; // Invalid format
    var d = new Date(date);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === date;
  }

  let editedDocumentObj = {
    documentTypeId: editDocumentTypeId,
    docId: editDocId,
    issuedFrom: editIssuedFrom,
    issuedDate: editIssuedDate,
    issuedDateBs: editIssuedDateBs,
    fileId: editFileId,
    fileName: editFileName,
  };

  const getFileName = (fileName) => {
    setEditFileName(fileName.fileName);
    setEditFileId(fileName.id);
  };

  const renderFooter = () => {
    return (
      <>
        <Button
          label="No"
          icon="pi pi-times"
          onClick={() => {
            hideModal();
          }}
          className="p-button-text"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          onClick={() => {
            hideModal();
            editDocumentDetail(editedDocumentObj);
          }}
        />
      </>
    );
  };

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm({});
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  return (
    <div className="dialog">
      <div className="card">
        <Dialog
          header={t("documentUpload")}
          visible={displayEditModal}
          style={{ width: "50%", height: "550px" }}
          footer={renderFooter}
          onHide={hideModal}
        >
          <div className="p-grid p-fluid">
            <div className="p-field p-col-12 p-md-12 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="documentType">
                {t("selectDocumentType")}
              </label>
              <Controller
                name="documentType"
                control={control}
                rules={{ required: "Document Type is required." }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    id={field.id}
                    {...field}
                    value={editDocumentTypeId}
                    onChange={(e) => {
                      setEditDocumentTypeId(e.value);
                    }}
                    options={documentTypeList}
                    optionLabel={"descEng"}
                    placeholder={t("selectDocumentType")}
                    optionValue={"code"}
                  />
                )}
              />
            </div>
            {getFormErrorMessage("documentType")}
            <div className="p-field p-col-12 p-md-12 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="docId">
                {t("docId")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="docId"
                  control={control}
                  rules={{ required: "Document is required." }}
                  render={({ field, fieldState }) => (
                    <Input
                      id={field.name}
                      {...field}
                      placeholder={t("docId")}
                      onChange={(e) => setEditDocId(e.target.value)}
                      value={editDocId}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                    />
                  )}
                />
              </div>
            </div>
            {getFormErrorMessage("docId")}

            <div className="p-field p-col-12 p-md-12 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="issuedDateBs">
                {t("issuedDateBs")}
              </label>
              <span className="p-input-icon-right">
                <i className="pi pi-calendar icon-front" />
                <NepaliDatePicker2
                  inputClassName="form-control p-inputtext p-component p-filled"
                  value={editIssuedDateBs}
                  onChange={(value) => {
                    setEditIssuedDateBs(value);
                    const checkDate = isValidDate(value);
                    if (checkDate) {
                      const convertedBsDate = bsToAd(value);
                      setEditIssuedDate(convertedBsDate);
                    }
                  }}
                />
              </span>
            </div>
            {getFormErrorMessage("issuedDateBs")}
            <div className="p-field p-col-12 p-md-12 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="issuedDate">
                {t("issuedDate")}
              </label>
              <span className="p-input-icon-right">
                <i className="pi pi-calendar icon-front" />
                <CalendarAD
                  mask="9999-99-99"
                  placeholder={t("issuedDate")}
                  //value={new Date(editIssuedDate)}
                  value={editIssuedDate}
                  onChange={(e) => {
                    if (!e.value) { return; }
                    try {

                      const date = e.value;
                      const convertedAdDate = adToBs(
                        new Date(
                          date.getTime() - date.getTimezoneOffset() * 60000
                        )
                          .toISOString()
                          .split("T")[0]
                      );
                      // setEditIssuedDate(date.toISOString().split("T")[0]);
                      setEditIssuedDate(new Date(date + "EDT"));
                      setEditIssuedDateBs(convertedAdDate);
                    } catch (e) {
                      alert("Date out of availability");
                      console.log(e);
                    }
                  }}
                  monthNavigator
                  yearNavigator
                  yearRange={"1900 : " + new Date().getFullYear()}
                  dateFormat="yy-mm-dd"
                />
              </span>
            </div>
            {getFormErrorMessage("issuedDate")}

            <div className="p-field p-col-12 p-md-12 stick-right">
              <label className="p-col-12 p-md-12" htmlFor="issuedFrom">
                {t("issuedFrom")}
              </label>
              <div className="p-inputgroup">
                <Controller
                  name="issuedFrom"
                  control={control}
                  rules={{ required: "Issued From is required." }}
                  render={({ field, fieldState }) => (
                    <Input
                      id={field.name}
                      {...field}
                      placeholder={t("issuedFrom")}
                      onChange={(e) => setEditIssuedFrom(e.target.value)}
                      value={editIssuedFrom}
                      className={classNames({
                        "p-invalid": fieldState.invalid,
                      })}
                    />
                  )}
                />
              </div>
            </div>
            {getFormErrorMessage("issuedFrom")}
            <div className="p-field p-col-12 p-md-12 stick-right">
              <label className="p-col-12 p-md-6">{t("uploadFile")}</label>
              <FileUploadComponent onUpload={getFileName} /> {editFileName}
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default EditDocDetails;
